import { useRef } from 'react';
import { SnackbarProvider as NotistackProvider, closeSnackbar } from 'notistack';
// @mui
// import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
//
import { StyledIcon, StyledNotistack } from './styles';

import InfoIcon from '@mui/icons-material/Info';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';
import CloseIcon from '@mui/icons-material/Close';

// ----------------------------------------------------------------------

type Props = {
    children: React.ReactNode;
};

export default function SnackbarProvider({ children }: Props) {

    const notistackRef = useRef<any>(null);

    return (
        <NotistackProvider
            ref={notistackRef}
            maxSnack={5}
            preventDuplicate
            autoHideDuration={3000}
            // TransitionComponent={isRTL ? Collapse : undefined}
            variant="success" // Set default variant
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            iconVariant={{
                info: (
                    <StyledIcon color="info">
                        <InfoIcon />
                    </StyledIcon>
                ),
                success: (
                    <StyledIcon color="success">
                        <CheckCircleIcon />
                    </StyledIcon>
                ),
                warning: (
                    <StyledIcon color="warning">
                        <WarningIcon />
                    </StyledIcon>
                ),
                error: (
                    <StyledIcon color="error">
                        <ErrorIcon />
                    </StyledIcon>
                )
            }}
            Components={{
                default: StyledNotistack,
                info: StyledNotistack,
                success: StyledNotistack,
                warning: StyledNotistack,
                error: StyledNotistack
            }}
            // with close as default
            action={(snackbarId) => (
                <IconButton size="small" onClick={() => closeSnackbar(snackbarId)} sx={{ p: 0.5 }}>
                    <CloseIcon />
                </IconButton>
            )}
        >
            {children}
        </NotistackProvider>
    );
}
